import { render, staticRenderFns } from "./HeroNeighbourhood.vue?vue&type=template&id=a30d2f44&scoped=true"
import script from "./HeroNeighbourhood.vue?vue&type=script&lang=js"
export * from "./HeroNeighbourhood.vue?vue&type=script&lang=js"
import style0 from "./HeroNeighbourhood.vue?vue&type=style&index=0&id=a30d2f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30d2f44",
  null
  
)

export default component.exports